import { allBackgrounds } from './background.js';
import type { ProjectDocument } from './types.js';

/**
 * Every stored file a document references (3D models of placed objects and the background
 * image), without duplicates.
 */
export function documentAssetIds(
  doc: Pick<ProjectDocument, 'objects' | 'background' | 'levelBackgrounds' | 'wallImages'>,
): string[] {
  return [
    ...new Set([
      ...Object.values(doc.objects).flatMap((o) => (o.source.kind === 'asset' ? [o.source.assetId] : [])),
      ...backgroundAssetIds(doc),
      ...wallImageAssetIds(doc),
    ]),
  ];
}

/** The images of all pictures and logos on walls. */
export const wallImageAssetIds = (doc: Pick<ProjectDocument, 'wallImages'>): string[] =>
  Object.values(doc.wallImages).map((p) => p.assetId);

/** The files of all floor plans: each image and the PDF it was drawn from. */
export const backgroundAssetIds = (
  doc: Pick<ProjectDocument, 'background' | 'levelBackgrounds'>,
): string[] =>
  allBackgrounds(doc).flatMap((b) => [b.assetId, ...(b.pdf ? [b.pdf.assetId] : [])]);
